import {ApiReferralRepository} from '@raf/core/infrastructure/domain/ApiReferralRepository';

import {GetReferral} from './GetReferral';
import {GetReferralForShare} from './GetReferralForShare';

export const ReferralApplication = {
  getReferral: GetReferral(ApiReferralRepository),
  getReferralForShare: GetReferralForShare(ApiReferralRepository),
};
